import React, {useEffect, useState} from "react";
import s from './NoEdit.module.css';
import {useStore} from "../../../hook/useStore";

const NoEdit = ({location, navigate_page, visible}) => {
    const [secondsLeft, setSecondsLeft] = useState(10);
    const {noEdit} = useStore();

    const isLocked = noEdit.mode === 'locked';

    const message = (
        <>
            Внимание! Карточки тренера{' '}
            <span>
      {isLocked ? 'закрыты' : 'открыты'}
    </span>{' '}
            для редактирования!
        </>
    );

    const handleProceed = () => {
        window.location.href = '/' + location?.search || '';
    };

    useEffect(() => {
        if (!visible) return;
        if (secondsLeft <= 0) {
            handleProceed();
            return;
        }

        const timer = setInterval(() => {
            setSecondsLeft((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(timer);
    }, [secondsLeft, location, navigate_page, visible]);

    if (!visible) return null;

    return (
        <div className={s.container} style={{
            border: isLocked ? '6px solid #DB0000' : '6px solid #5CB646',
            borderRadius: '15px'
        }} >
            <span className={s.text}>{message}</span>
            <div className={s.text__block}>
                <span className={s.timer__text}>Страница обновится через </span>
                <span className={s.timer__text}>{secondsLeft} сек</span>
            </div>
            <button className={s.button} onClick={handleProceed}>OK</button>
        </div>
    );
};

export default NoEdit;